import React, {useState} from "react";
import styled from "styled-components";
import BurguerButton from "./BurguerButton";

import HomeIcon from '@mui/icons-material/Home';

const logo = "Banner Web.png";
export default function NavBar() {
    const [clicked, setClicked] = useState(false);
    const handleClick = () => {
        setClicked(!clicked);
    }
    return (
        <>
            <NavContaniner>

                 <div>
                    <img src={process.env.PUBLIC_URL + require(`../imagenes/${logo}`)}
                         alt={"logo"}

                     />
                </div>

                <div className={`links ${clicked ? "active" : ""}`}>
                    <a onClick={handleClick} href={"/inicio"}><HomeIcon/></a>
                    <a onClick={handleClick} href={"/expediciones"}>Expediciones</a>
                    <a onClick={handleClick} href={"/reservas"}>Reservas</a>
                    <a onClick={handleClick} href={"/turismo-cerca"}>Turismo Cerca</a>
                    <a onClick={handleClick} href={"/acerca-de"}>Acerca de</a>
                    <a className={"boton-enfasis"} onClick={handleClick} href={"/contacto"}>Contacto</a>


                </div>
                <div className={"burguer"}>
                <BurguerButton clicked={clicked} handleClick={handleClick}/>
                </div>
                <BgDiv className={`initial ${clicked ? "active" : ""}`}></BgDiv>

            </NavContaniner>

        </>
    );
}

//<h2>Temporarios<br/> <span>Balcón del Pissis</span></h2>


const NavContaniner = styled.nav`
    /* AGREGAR: posicionamiento fijo sobre todo */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 100;
    
    padding: .4rem 1rem;
    //display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7);  /* fondo semitransparente sobre el banner */
    backdrop-filter: blur(4px);             /* efecto glass opcional */

    h2 {
        font-weight: 400;
        span { font-weight: bold; }
    }
    img {
        zoom: 45%;
        margin-top: 0px;
        width: -webkit-fill-available;
    }
    @media (max-width: 450px) {
        img {
            zoom: 25%;
            margin-top: 0px;
        }
    };

    a {
        color: white;
        text-decoration: none;
        margin: 0 1rem;
    }

    .burguer {
        @media (min-width: 768px) {
            display: none;
        };
    }

    /* EN MÓVIL: links ocultos fuera de pantalla por defecto */
    .links {
        position: absolute;
        top: -700px;
        left: -2000px;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        transition: all 1s ease;

        a {
            color: white;
            font-size: 1.5rem;
            display: block;
        }

        /* EN DESKTOP: links visibles en línea */
        @media (min-width: 768px) {
            position: initial;
            margin: 0;
            display: flex;
            align-items: center;
            gap: 1.25rem;
            a {
                color: white;
                font-size: 1rem;
                display: inline;
            }
            .boton-enfasis {
                margin-left: 0.75rem;
            }
        }
    }

    /* EN MÓVIL: links visibles cuando está activo */
    .links.active {
        width: 100%;
        display: block;
        position: absolute;
        top: 100%;          /* <-- CAMBIO: antes era 10%, ahora justo debajo del nav */
        left: 0;
        right: 0;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.9);
        padding: 1rem 0;
        z-index: 99;

        a {
            font-size: 1.5rem;
            margin-top: 1rem;
            color: white;
        }
    }
    .links a:hover {
        color: #b266d2;
    }
`
const BgDiv = styled.div`
    background-color: rgba(0,0,0,0);  /* lo hacemos invisible, ya el .links.active tiene fondo */
    position: absolute;
    top: -700px;
    left: -1500px;
    width: 100%;
    height: 100%;
    z-index: -1;
    transition: all 1s ease;

    &.active {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
    }
`